/* BMC Landing TEAM — buy flow for the two sales-team landing pages
   (challenge-offer / 60-day-offer). Loaded with data-cfasync="false" (external
   assets run on this store; inline scripts are killed by Rocket Loader).

   1) Running total + checkbox visuals for the stacked add-on cards. A card can
      carry SEVERAL variant ids (combo / bundle cards); one checkbox adds all of
      them. On the challenge page the "starter" bundle fully contains the
      "theory" bundle, so those two are mutually exclusive: checking one
      unchecks the other, which keeps the shown total equal to the cart total.
   2) CART FIX (same incident as the ad pages): a store app globally hijacks
      native /cart/add form submits and chokes on multi-item items[]. We take
      the click in the CAPTURE phase + stopImmediatePropagation, zero the
      funnel variants via /cart/update.js (re-clicks can never stack), then
      /cart/add.js adds main + every checked card's variants at qty 1, then
      opens /cart. No-JS fallback: the form posts the MAIN item only.
   3) NO cart-drawer takeover here: every #bmc-lp-buy anchor keeps its native
      scroll so the visitor lands on the add-on stack (Dan 2026-07-27: "we
      click and it scrolls us down to the place to add things on").
   window.__bmcLPTeam marks that this ran. */
(function () {
  window.__bmcLPTeam = true;
  var form = document.getElementById('bmc-lp-form');
  if (!form) return;

  var cfg = null;
  try {
    var cfgEl = document.getElementById('bmc-team-offer-data');
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {}
  if (!cfg || !cfg.cards) return;

  // starter fully contains theory (challenge page) AND the release combo
  // (60-day page): never both, or the shown total would exceed the cart total.
  // Keys missing from a page resolve to no checkbox and are skipped.
  var EXCLUDES = { starter: ['theory', 'release'], theory: ['starter'], release: ['starter'] };

  var totalEl = document.getElementById('bmc-lp-total');
  var btn = form.querySelector('button[type=submit]');
  // thousands separators: the card prices are written "+$1,900", so the running
  // total must read "$1,949", not "$1949"
  function money(c) {
    var s = (c / 100).toFixed(2).replace(/\.00$/, '');
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }
  function cardBox(key) {
    var opt = form.querySelector('.bmc-lp-opt[data-card="' + key + '"]');
    return opt ? opt.querySelector('input[type=checkbox]') : null;
  }

  function sync() {
    var total = cfg.base || 0;
    var opts = form.querySelectorAll('.bmc-lp-opt');
    for (var i = 0; i < opts.length; i++) {
      var c = opts[i].querySelector('input[type=checkbox]');
      if (!c) continue;
      if (c.checked) opts[i].classList.add('is-on'); else opts[i].classList.remove('is-on');
    }
    for (var j = 0; j < cfg.cards.length; j++) {
      var box = cardBox(cfg.cards[j].key);
      if (box && box.checked) total += cfg.cards[j].price;
    }
    if (totalEl) totalEl.textContent = money(total);
  }

  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'checkbox' && t.checked) {
      var opt = t.closest('.bmc-lp-opt');
      var key = opt ? opt.getAttribute('data-card') : null;
      var ex = key && EXCLUDES[key] ? EXCLUDES[key] : [];
      for (var i = 0; i < ex.length; i++) {
        var other = cardBox(ex[i]);
        if (other) other.checked = false;
      }
    }
    sync();
  });
  sync();

  var POST = { method: 'POST', credentials: 'same-origin',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' } };

  var adding = false;
  function addToCart(e) {
    if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
    if (adding) return;
    adding = true;
    sync();
    var mainInput = form.querySelector('input[name="items[0][id]"]');
    var mainId = mainInput ? mainInput.value : null;
    if (!mainId) { adding = false; return; }

    // union of every checked card's variants; dedupe as a backstop so the same
    // course can never be posted twice even if the exclusion rule is bypassed
    var addIds = [mainId], seen = {};
    seen[String(mainId)] = true;
    for (var i = 0; i < cfg.cards.length; i++) {
      var card = cfg.cards[i];
      var box = cardBox(card.key);
      if (!box || !box.checked) continue;
      for (var v = 0; v < card.variants.length; v++) {
        var id = String(card.variants[v]);
        if (seen[id]) continue;
        seen[id] = true;
        addIds.push(id);
      }
    }

    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Adding to cart...'; }
    function fail() { adding = false; if (btn) { btn.removeAttribute('disabled'); btn.textContent = label; } }

    // 1) clear every funnel variant (removes stacked duplicates + same-course
    //    twins from the ad pages). Empty strings = a team product that did not
    //    exist at render time; skip them.
    var clr = new URLSearchParams();
    (cfg.zero || []).forEach(function (id) { if (id) clr.append('updates[' + id + ']', '0'); });
    // mark the order for later reconciling: this sale came off a sales-team page
    clr.append('attributes[bmc_src]', 'team-lp');
    fetch('/cart/update.js', Object.assign({ body: clr.toString() }, POST))
      .then(function () {
        // 2) add exactly the current selection at qty 1
        var p = new URLSearchParams();
        for (var n = 0; n < addIds.length; n++) {
          p.append('items[' + n + '][id]', addIds[n]);
          p.append('items[' + n + '][quantity]', '1');
        }
        return fetch('/cart/add.js', Object.assign({ body: p.toString() }, POST));
      })
      .then(function (r) { if (r && r.ok) { window.location.href = '/cart'; return; } fail(); })
      .catch(fail);
  }
  if (btn) btn.addEventListener('click', addToCart, true); // capture: run before the app's handler
  form.addEventListener('submit', addToCart, true);        // Enter-key path

  // ---- Sticky bottom bar: only show BETWEEN the hero CTA and the offer block ----
  // Plain scroll + geometry, NOT IntersectionObserver: an app on this store breaks
  // IO globally (fresh observers never fire), which froze the bar on the ad pages.
  var stickyBar = document.querySelector('.bmc-lp-bar');
  var heroCta = document.querySelector('.bmc-lp-intro__ctawrap, .bmc-lp-chal__ctawrap');
  var offerForm = form;
  if (stickyBar && heroCta) {
    stickyBar.style.transition = 'transform .18s ease, opacity .18s ease';
    var setBar = function (show) {
      stickyBar.style.transform = show ? 'translateY(0)' : 'translateY(115%)';
      stickyBar.style.opacity = show ? '1' : '0';
      stickyBar.style.pointerEvents = show ? 'auto' : 'none';
    };
    var vis = function (el) {
      if (!el) return false;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var r = el.getBoundingClientRect();
      return r.bottom > 0 && r.top < vh;
    };
    var evalBar = function () { setBar(!vis(heroCta) && !vis(offerForm)); };
    var pend = false;
    var onMove = function () {
      if (pend) return;
      pend = true;
      requestAnimationFrame(function () { pend = false; evalBar(); });
    };
    window.addEventListener('scroll', onMove, { passive: true });
    window.addEventListener('resize', onMove, { passive: true });
    evalBar();
  }

  // Single-path funnel: repoint any /cart or /checkout link inside the ported sales
  // copy to the offer block so every CTA flows through the add-on-aware form.
  var links = document.querySelectorAll('.bmc-lp a[href*="/cart"], .bmc-lp a[href*="/checkout"]');
  for (var j = 0; j < links.length; j++) {
    var a = links[j];
    if (a.closest('#bmc-lp-form') || a.closest('.bmc-lp-bar') || a.getAttribute('href').charAt(0) === '#') continue;
    a.setAttribute('href', '#bmc-lp-buy');
    a.removeAttribute('target');
  }

  // ---- Block the 10% discount / email-signup popup on these landing pages ----
  function hidePopupRoot(el) {
    var top = el, hop = 0;
    while (top.parentElement && hop < 6) { var ps = getComputedStyle(top.parentElement); if (ps.position === 'fixed' || ps.position === 'absolute') top = top.parentElement; hop++; }
    if (top.closest && top.closest('.bmc-lp')) return;
    top.style.setProperty('display', 'none', 'important');
  }
  function killPromoPopups() {
    try {
      var known = document.querySelectorAll('[class*="klaviyo-form"],[class*="kl-private-reset"],[class*="kl-teaser"],[id^="klaviyo"]');
      for (var i = 0; i < known.length; i++) { if (!known[i].closest('.bmc-lp')) known[i].style.setProperty('display', 'none', 'important'); }
      var all = document.querySelectorAll('div,section,aside,dialog,form');
      for (var k = 0; k < all.length; k++) {
        var el = all[k], st = getComputedStyle(el);
        if (st.position !== 'fixed' && st.position !== 'absolute') continue;
        if ((parseInt(st.zIndex, 10) || 0) < 50) continue;
        if (el.closest('.bmc-lp') || el.offsetHeight < 60) continue;
        if (/10\s*%|10\s*percent/i.test(el.textContent || '')) hidePopupRoot(el);
      }
      document.documentElement.style.overflow = ''; if (document.body) document.body.style.overflow = '';
    } catch (e) {}
  }
  killPromoPopups();
  var kpN = 0, kpTimer = setInterval(function () { killPromoPopups(); if (++kpN > 45) clearInterval(kpTimer); }, 800); // watch ~36s
  if (window.MutationObserver) {
    var kpPending = false;
    new MutationObserver(function () { if (kpPending) return; kpPending = true; setTimeout(function () { kpPending = false; killPromoPopups(); }, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
